export default __webpack_public_path__ + "static/media/close_icon_white.5decab4a.svg";